module.exports = __webpack_public_path__ + "img/structure.82b43c56.svg";